import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    DataServiceError,
    DefaultDataServiceConfig,
    EntitySelectors,
    EntitySelectorsFactory,
    HttpUrlGenerator
} from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, flatMap, map, take } from 'rxjs/operators';
import { IDeleteEntity, IGenericResponse } from '../../common';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { EfaactDataService } from '../efaact.data-service';
import { ManualAdjustment } from './manual-adjustment.model';

export const entityName = 'ManualTxn';

@Injectable()
export class ManualAdjustmentDataService extends EfaactDataService<ManualAdjustment> {
    selectors: EntitySelectors<ManualAdjustment>;
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.selectors = new EntitySelectorsFactory().create<ManualAdjustment>(
            this.entityName
        );
    }
    delete(key: number | string): Observable<number | string> {
        this.log.verbose({
            type: `${this.entityName}DataService(ManualAdjustmentDataService):delete`,
            key
        });
        return this.store.pipe(
            select(this.selectors.selectEntities),
            take(1),
            map(items => items.find(item => item.id === key)),
            flatMap(item => {
                const params = {
                    EntityIDs: [key],
                    directtype: item.Txntype
                };
                return this.http
                    .request<IGenericResponse<IDeleteEntity>>(
                        'DELETE',
                        this.entitiesUrl,
                        {
                            body: params
                        }
                    )
                    .pipe(
                        map(resp => this.mapPutResponse(resp)),
                        map(resp => {
                            if (
                                !fromShared.Errors.IsSuccessStatus(
                                    resp.StatusCode
                                )
                            ) {
                                this.store.dispatch(
                                    new fromShared.Errors.SetErrors(
                                        fromShared.Errors.MapErrorsToStatus(
                                            resp
                                        )
                                    )
                                );
                                throwError(
                                    new DataServiceError(
                                        fromShared.Errors.getResponseErrors(
                                            resp
                                        ).reduce(
                                            (a, c, i) =>
                                                i === 0 ? c : `${a}\n${c}`,
                                            ''
                                        ),
                                        {
                                            method: 'DELETE',
                                            url: this.entitiesUrl
                                        }
                                    )
                                );
                            }
                            return (resp.Items[0] as any).EntityID as
                                | string
                                | number;
                        }),
                        catchError((e, c) =>
                            fromShared.Errors.handleDataServiceError(
                                this.store,
                                e,
                                c
                            )
                        )
                    );
            })
        );
        // .subscribe(entity => );
        // const keys = (key as string).split(',');
    }

    mapItems(item: ManualAdjustment): ManualAdjustment {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.Txnid
            // FeeRetainPercentStartDate: moment(item.FeeRetainPercentStartDate).isValid() ? moment(item.FeeRetainPercentStartDate).toDate() : null
        };
    }
}
